import React from 'react';
import { motion } from 'framer-motion';
import { Ticket, Hotel, Plane, Car, MessageCircle, Tag } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function TicketsEvents() {
  const {
    t
  } = useLanguage();
  const whatsappNumber = '14699895608';
  const deals = [{
    title: t('deals.tickets'),
    desc: t('deals.ticketsDesc'),
    icon: <Ticket className="text-colombia-yellow" size={24} data-id="element-356" />,
    cta: t('deals.findTickets'),
    link: `https://wa.me/${whatsappNumber}?text=Hello%2C%20I'm%20interested%20in%20purchasing%20FIFA%20World%20Cup%202026%20tickets.%20I'd%20like%20to%20apply%20the%20QTAP26%20discount.%20Could%20you%20share%20available%20packages%20and%20pricing%3F%20Thank%20you.`
  }, {
    title: t('deals.hotels'),
    desc: t('deals.hotelsDesc'),
    icon: <Hotel className="text-colombia-yellow" size={24} data-id="element-357" />,
    cta: t('deals.bookHotels'),
    link: `https://wa.me/${whatsappNumber}?text=Hello%2C%20I'm%20looking%20for%20hotel%20accommodations%20for%20the%20FIFA%20World%20Cup%202026%20in%20the%20USA.%20I'd%20like%20to%20apply%20the%20QTAP26%20discount.%20Could%20you%20share%20available%20options%20and%20rates%3F%20Thank%20you.`
  }, {
    title: t('deals.flights'),
    desc: t('deals.flightsDesc'),
    icon: <Plane className="text-colombia-yellow" size={24} data-id="element-358" />,
    cta: t('deals.searchFlights'),
    link: `https://wa.me/${whatsappNumber}?text=Hello%2C%20I'm%20searching%20for%20flights%20to%20the%20FIFA%20World%20Cup%202026%20host%20cities.%20I'd%20like%20to%20apply%20the%20QTAP26%20discount.%20Could%20you%20help%20me%20find%20the%20best%20options%3F%20Thank%20you.`
  }, {
    title: t('deals.transport'),
    desc: t('deals.transportDesc'),
    icon: <Car className="text-colombia-yellow" size={24} data-id="element-359" />,
    cta: t('deals.planTransport'),
    link: `https://wa.me/${whatsappNumber}?text=Hello%2C%20I%20need%20ground%20transportation%20for%20the%20FIFA%20World%20Cup%202026.%20I'd%20like%20to%20apply%20the%20QTAP26%20discount.%20Could%20you%20share%20available%20transport%20packages%3F%20Thank%20you.`
  }];
  return <section id="deals" className="py-12 md:py-24 bg-[#111] border-t border-white/5" data-id="element-360">
      <div className="container mx-auto px-6 md:px-12" data-id="element-361">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-12" data-id="element-362">
          <h2 className="text-colombia-blue font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-363">
            {t('deals.label')}
          </h2>
          <h3 className="text-3xl md:text-5xl font-oswald font-bold uppercase mb-6" data-id="element-364">
            {t('deals.title1')}{' '}
            <span className="text-colombia-yellow" data-id="element-365">{t('deals.title2')}</span>
          </h3>
          <p className="text-gray-400" data-id="element-366">{t('deals.desc')}</p>
        </motion.div>

        {/* Promo Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-colombia-dark-blue to-colombia-blue rounded-2xl p-6 md:p-8 mb-12 flex flex-col md:flex-row items-center justify-between gap-6 border border-colombia-yellow/30 shadow-[0_0_30px_rgba(0,56,147,0.2)]" data-id="element-367">
          <div className="flex items-center gap-4" data-id="element-368">
            <div className="bg-colombia-yellow text-colombia-black p-3 rounded-full" data-id="element-369">
              <Tag size={24} data-id="element-370" />
            </div>
            <div data-id="element-371">
              <h4 className="font-oswald text-xl md:text-2xl font-bold uppercase text-white" data-id="element-372">
                {t('deals.unlockVip')}
              </h4>
              <p className="text-white/80 text-sm" data-id="element-373">{t('deals.applyCode')}</p>
            </div>
          </div>
          <div className="bg-colombia-black/50 border border-colombia-yellow/50 px-6 py-3 rounded-lg font-oswald text-2xl tracking-widest text-colombia-yellow font-bold select-all" data-id="element-374">
            QTAP26
          </div>
        </motion.div>

        {/* Deals Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-375">
          {deals.map((deal, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-[#0a0a0a] p-4 md:p-8 rounded-xl md:rounded-2xl border border-white/5 hover:border-colombia-yellow transition-colors duration-300 flex flex-col h-full group" data-id="element-376">
              <div className="bg-white/5 w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl flex items-center justify-center mb-3 md:mb-6 group-hover:bg-colombia-yellow/10 transition-colors" data-id="element-377">
                {deal.icon}
              </div>
              <h4 className="font-oswald text-sm md:text-xl font-bold uppercase mb-1 md:mb-2 text-white leading-tight" data-id="element-378">
                {deal.title}
              </h4>
              <p className="text-[10px] md:text-sm text-gray-400 mb-4 md:mb-8 flex-grow leading-relaxed" data-id="element-379">
                {deal.desc}
              </p>
              <a href={deal.link} target="_blank" rel="noopener noreferrer" className="w-full bg-transparent border-2 border-[#25D366] hover:bg-[#25D366] hover:text-white text-[#25D366] px-3 md:px-6 py-2.5 md:py-3 rounded-lg md:rounded-xl font-oswald uppercase tracking-wider text-[10px] md:text-sm font-bold transition-all duration-300 flex items-center justify-center gap-1.5 md:gap-2 min-h-[44px]" data-id="element-380">
                {deal.cta} <MessageCircle size={12} className="md:w-4 md:h-4" data-id="element-381" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}